/* =================== CARROSSEL PRUDUTOS =================== */
$(function () {
  $(".carrosel-produtos").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: false,
    dots: $(".carrosel-produtos .bl-produto-cat").length > 4,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: $(".carrosel-produtos .bl-produto-cat").length > 1,
        },
      },
    ],
  });

  $(".carrosel-produtos-relacionados").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: false,
    dots: $(".carrosel-produtos-relacionados .bloco-produto").length > 5,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: $(".carrosel-produtos-relacionados .bloco-produto").length > 2,
        },
      },
    ],
  });

  $(".carrosel-produtos-categorias").slick({
    slidesToShow: 6,
    slidesToScroll: 6,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });
});
